import { hasPermission } from "./matching";
import { platformPermission } from "./jwt";

/** Platform (RECYCLEE Admin) approval permissions */
export const PLATFORM_APPROVAL_PERMISSIONS = {
  list: platformPermission("approval", "list"),
  read: platformPermission("approval", "read"),
  submit: platformPermission("approval", "submit"),
  write: platformPermission("approval", "write"),
} as const;

/** Tenant (ZERO) approval permissions — substitute orgId */
export function tenantApprovalPermissions(orgId: string) {
  const prefix = `recyclee.${orgId}.*.approval`;
  return {
    list: `${prefix}.list`,
    read: `${prefix}.read`,
    submit: `${prefix}.submit`,
    write: `${prefix}.write`,
  } as const;
}

export function canViewApprovalInbox(
  permissionList: readonly string[],
  orgId?: string,
): boolean {
  if (permissionList.includes("*")) return true;
  if (hasPermission(permissionList, PLATFORM_APPROVAL_PERMISSIONS.list)) {
    return true;
  }
  if (orgId) {
    const perms = tenantApprovalPermissions(orgId);
    return (
      hasPermission(permissionList, perms.list) ||
      hasPermission(permissionList, `recyclee.${orgId}.*`)
    );
  }
  return false;
}

export function canReadApprovalDetail(
  permissionList: readonly string[],
  orgId?: string,
): boolean {
  if (permissionList.includes("*")) return true;
  if (hasPermission(permissionList, PLATFORM_APPROVAL_PERMISSIONS.read)) {
    return true;
  }
  if (orgId) {
    const perms = tenantApprovalPermissions(orgId);
    return (
      hasPermission(permissionList, perms.read) ||
      hasPermission(permissionList, `recyclee.${orgId}.*`)
    );
  }
  return false;
}

export function canSubmitApprovals(
  permissionList: readonly string[],
  orgId?: string,
): boolean {
  if (permissionList.includes("*")) return true;
  if (hasPermission(permissionList, PLATFORM_APPROVAL_PERMISSIONS.submit)) {
    return true;
  }
  if (orgId) {
    const perms = tenantApprovalPermissions(orgId);
    return (
      hasPermission(permissionList, perms.submit) ||
      hasPermission(permissionList, `recyclee.${orgId}.*`)
    );
  }
  return false;
}

export function canApproveRequests(
  permissionList: readonly string[],
  orgId?: string,
): boolean {
  if (permissionList.includes("*")) return true;
  if (hasPermission(permissionList, PLATFORM_APPROVAL_PERMISSIONS.write)) {
    return true;
  }
  if (orgId) {
    const perms = tenantApprovalPermissions(orgId);
    return (
      hasPermission(permissionList, perms.write) ||
      hasPermission(permissionList, `recyclee.${orgId}.*`)
    );
  }
  return false;
}
